import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PASTEL } from "./tokens";

/**
 * Large pastel action card used on the dashboard.
 *   <FeatureCard title="Raise Enquiry" Icon={FileText} tone="indigo" to="/enquiries/new" testid="feat-enquiry" />
 */
export function FeatureCard({ title, subtitle, Icon, tone = "emerald", to, onClick, testid }) {
  const t = PASTEL[tone] || PASTEL.emerald;
  const Body = (
    <div
      data-testid={testid}
      className={`group ${t.card} rounded-3xl p-5 h-[152px] flex flex-col justify-between transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer relative overflow-hidden`}
    >
      <div className="flex items-start justify-between">
        <div className={`w-12 h-12 rounded-2xl grid place-items-center shadow-sm ${t.icon}`}>
          {Icon && <Icon className="w-6 h-6" strokeWidth={2.2} />}
        </div>
        <div className="w-8 h-8 rounded-full bg-white/70 grid place-items-center transition-transform duration-300 group-hover:rotate-45">
          <ArrowUpRight className="w-4 h-4 text-slate-700" strokeWidth={2.5} />
        </div>
      </div>
      <div>
        <div className="text-base font-bold text-slate-900 leading-tight">{title}</div>
        {subtitle && <div className="text-xs text-slate-500 mt-0.5 line-clamp-1">{subtitle}</div>}
      </div>
    </div>
  );
  if (to) return <Link to={to}>{Body}</Link>;
  return <button type="button" onClick={onClick} className="text-left w-full">{Body}</button>;
}
